import Loadable from './../Loadable';
import lazyWithRetry from './../lazyWithRetry';
import AuthWrapper from '../../Screens/AuthLayouts/AuthWrapper';
import { Navigate } from 'react-router-dom';
import { ForgotPassword, ResetPassword } from '../../Screens/AuthLayouts/ForgotPassword';
// import AdminForgotPassword from '../../Screens/AuthLayouts/AdminForgotPassword';
const SignIn = Loadable(lazyWithRetry(() => import('../../Screens/AuthLayouts/SignIn')));
const NotFound = Loadable(lazyWithRetry(() => import('../../Screens/AdminLayouts/NotFound404')));


// Helper function to check authentication
function isUserAuthenticated() {
  const result = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_STORAGE_KEY}/auth`) || '{}');
  return !!result?._id;
}

const AuthRoutes = {
  path: 'admin',
  element: <AuthWrapper isAuthenticated={isUserAuthenticated()} />,
  children: [
    {
      path: '',
      element: <Navigate to="/login" replace />, 
      pathMatch: 'full'
    },
    {
      path: 'login',
      element: <SignIn />
    },
    {
      path: 'forgot-password',
      element: <ForgotPassword />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />,
    },
  ]
};

export default AuthRoutes;


// /reset-password?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2Nzk4ZTA0YzZmOWRmNmM0YjMyNDFhMmMiLCJpYXQiOjE3MzkyNjQ4MzMsImV4cCI6MTczOTI2NTQzM30.VTeOtC6lDT07J4g70hp9R_9wVk1LO6Oi9gegP8FTVvk